// extracted by mini-css-extract-plugin
module.exports = {"Checkbox__Label":"ToggleSwitch_Checkbox__Label__2qbog","Checkbox":"ToggleSwitch_Checkbox__1q-wE","Checkbox__Slider":"ToggleSwitch_Checkbox__Slider__3W06_"};